import { ACTION_TYPES } from './actionTypes'

export const matchDebitAction = (payload) => ({
	type: ACTION_TYPES.MATCH_DEBIT,
	payload,
})
